import React, { useEffect, useRef, useState } from "react";
import { Check, Copy } from "lucide-react";

export async function copyText(value) {
  const text = String(value);
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Some in-app browsers deny Clipboard API access; try their native copy.
    }
  }

  const previouslyFocused = document.activeElement;
  const input = document.createElement("textarea");
  input.value = text;
  input.setAttribute("readonly", "");
  input.style.cssText = "position:fixed;top:0;left:-9999px;font-size:16px";
  document.body.appendChild(input);
  try {
    input.select();
    input.setSelectionRange(0, text.length);
    if (!document.execCommand?.("copy")) throw new Error("Copy unavailable");
  } finally {
    input.remove();
    previouslyFocused?.focus?.({ preventScroll: true });
  }
}

export default function CopyButton({ value, label = "Sao chép", className = "" }) {
  const [state, setState] = useState("idle");
  const timer = useRef();
  useEffect(() => () => window.clearTimeout(timer.current), []);

  async function handleCopy() {
    window.clearTimeout(timer.current);
    try {
      await copyText(value);
      setState("copied");
    } catch {
      setState("error");
    }
    timer.current = window.setTimeout(() => setState("idle"), 4000);
  }

  return (
    <span className="inline-flex max-w-full flex-col items-start gap-1">
      <button
        type="button"
        onClick={handleCopy}
        className={`inline-flex min-h-11 items-center justify-center gap-2 rounded-lg border border-[var(--color-border-soft)] bg-white px-3 py-2 text-sm font-semibold text-[var(--color-primary)] transition hover:bg-orange-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-primary)] ${className}`}
      >
        {state === "copied" ? <Check size={16} aria-hidden="true" /> : <Copy size={16} aria-hidden="true" />}
        {label}
      </button>
      <span role="status" className={`text-xs ${state === "error" ? "text-red-700" : "text-green-700"}`}>
        {state === "copied" && "Đã sao chép"}
        {state === "error" && "Chưa sao chép được. Vui lòng chọn và sao chép thông tin thủ công."}
      </span>
    </span>
  );
}
